export class Program{
    id: number;
    name: string;
    description: string;
    code:string;
   
}